export function secondsToDHM(seconds) {
	const date = Number(seconds);
	const d = Math.floor(date / 86400);
	const h = Math.floor(date % 86400 / 3600 % 24);
	const m = Math.floor(date % 86400 / 60  % 60);

	return [d, h, m];
}

export function secondsToHMS(seconds) {
	const date = Number(seconds);
	const h = Math.floor(date % 86400 / 3600 % 24);
	const m = Math.floor(date % 86400 / 60  % 60);
	const s = Math.floor(date % 86400 % 60);

	return [h, m, s];
}

export function addDays(date, days) {
	const copy = new Date(Number(date));
	copy.setDate(date.getDate() + days);
	return copy
}